import { render, staticRenderFns } from "./WheelBattleJerseyColorPicker.vue?vue&type=template&id=2ff72388&scoped=true&"
import script from "./WheelBattleJerseyColorPicker.vue?vue&type=script&lang=js&"
export * from "./WheelBattleJerseyColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleJerseyColorPicker.vue?vue&type=style&index=0&id=2ff72388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff72388",
  null
  
)

export default component.exports